// extracted by mini-css-extract-plugin
export default {"root":"Header_root__tkoSk","content":"Header_content__ibjFN","user":"Header_user__shkjG","navigation":"Header_navigation__yN6oY"};